import React, { useState, useEffect, useContext } from 'react';
import { Box, Grid, Paper, Typography, TextField, Autocomplete, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, CircularProgress } from '@mui/material';
import ApiService from "../../functions/apiService";
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Modal from 'react-bootstrap/Modal';
import CollapseComponent from '../../components/Schedule/CollapseComponent';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

const AllSignups = () => {
    const { permission, v3Data, pages } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [empName, setEmpName] = useState([]);
    const [activeTab, setActiveTab] = useState('all-signups');
    const [employees, setEmployees] = useState([]);
    const navigate = useNavigate();
    const [fromDate, setFromDate] = useState(new Date());
    const oneMonthAfter = new Date();
    oneMonthAfter.setMonth(oneMonthAfter.getMonth() + 1);
    const [endDate, setEndDate] = useState(oneMonthAfter);
    const [assignModalOne, setAssignModalOne] = useState(false);
    const [assignModalMultiple, setAssignModalMultiple] = useState(false);
    const [availableCount, setAvailableCount] = useState(0)
    const [displayTab, setDisplayTab] = useState('display_by_emp');
    const [employeeName, setEmployeeName] = useState([]);
    const [shiftOptions, setShiftOptions] = useState([]);
    const [assignedTo, setAssignedTo] = useState('');
    const [assignShiftDate, setAssignShiftDate] = useState('');
    const [assignShiftCode, setAssignShiftCode] = useState('');
    const [assignEmpCode, setAssignEmpCode] = useState('');
    const [assignStartTime, setAssignStartTime] = useState('');
    const [assignEndTime, setAssignEndTime] = useState('');
    const [assignStartTimeCustom, setAssignStartTimeCustom] = useState('');
    const [assignEndTimeCustom, setAssignEndTimeCustom] = useState('');
    const [assignEmpName, setAssignEmpName] = useState('');
    const [assignDate, setAssignDate] = useState('');
    const [employeesAssign, setEmployeesAssign] = useState([]);
    const [employeeAssignName, setEmployeeAssignName] = useState('');
    const [isCustom, setIsCustom] = useState(false)
    const [isFultime, setIsFulltime] = useState('')
    const [unAssignModal, setUnAssignModal] = useState(false);
    const [employeesUnAssign, setEmployeesUnAssign] = useState([]);
    const [unAssignData, setUnAssignData] = useState('')
    const [unAssignEmpCode, setUnAssignEmpCode] = useState('')
    const [unAssignPosId, setUnAssignPosId] = useState('')

	const getColumns = (tab) => {
		const groupColumn = {
			field: 'group', headerName: 'Group', flex: 1, maxWidth: 120,
			renderCell: (params) => {
				const code = params.row.shift_code;
				return (
					<div style={{
						color: "#000000",
						fontSize: "16px",
						fontWeight: "400",
						backgroundColor: "#C0DFF4",
						borderRadius: 50,
						padding: '2px 10px',
						width: "60px",
						height: "30px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center"
					}}>
						{code}
					</div>
				);
			}
		};

		const shiftStatusColumn = {
			field: 'status', headerName: 'Shift Status', flex: 1, minWidth: 150, maxWidth: 150,
			renderCell: (params) => {
				const Shift = params.row.shift_status ? params.row.shift_status.charAt(0).toUpperCase() + params.row.shift_status.slice(1) : '';
				const Fill = params.row.positions_filled ? params.row.positions_filled : '0'
				const isOpen = displayTab === 'display_by_date' ? params.row.shift_status === 'open' : params?.row?.isFilledBySelf === false;
				return (
					<div style={{
						color: "#000000",
						fontSize: "14px",
						fontWeight: "400",
						backgroundColor: isOpen ? "#FF383C80" : "#E5E7EB",
						borderRadius: 50,
						padding: '2px 10px',
						width: "95px",
						height: "35px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center"
					}}>
						{displayTab === 'display_by_date' && params.row.shift_status === 'filled'
							? (Shift + " (" + Fill + ")")
							: (params?.row?.isFilledBySelf === true ? "Filled" : "Open")}
					</div>
				);
			}
		};

		const actionColumn = {
			field: 'action',
			headerName: 'Action',
			flex: 1,
			minWidth: 180,
			maxWidth: 180,
			renderCell: (params) =>
				permission.includes('Emp_Auth') && (
					<>
						<ButtonTheme
							className='px-2 mt-1'
							disabled={
								displayTab !== 'display_by_date' &&
								params?.row?.isFilledBySelf === true
							}
							style={{
								backgroundColor:
									params?.row?.isFilledBySelf === true && displayTab !== 'display_by_date'
										? '#A0A0A0'
										: '#BF1D2D',
								// backgroundColor: '#BF1D2D',
								borderRadius: '10px',
								gap: '3px',
								padding: '4px',
							}}
							onClick={() => {
								setIsCustom(params?.row?.is_custom)
								setIsFulltime(params?.row?.is_fulltime)
								setAssignStartTime(params?.row?.shift_start_time ? new Date(`${moment().format('YYYY-MM-DD')} ${params?.row?.shift_start_time}`) : params?.row?.start_time);
								setAssignEndTime(params?.row?.shift_end_time ? new Date(`${moment().format('YYYY-MM-DD')} ${params?.row?.shift_end_time}`) : params?.row?.end_time);
								shiftDropdown(params?.row?.shift_date, params?.row?.shift_code)
								displayTab === 'display_by_date' && loadDropEmployees(params?.row?.shift_date, params?.row?.shift_code)
								displayTab === 'display_by_date' ? setAssignModalMultiple(true) : setAssignModalOne(true);
								setAssignShiftCode(params?.row?.shift_code);
								setAssignShiftDate(params?.row?.shift_date);
								setAssignEmpCode(params?.row?.Emp_Code);
								setAssignEmpName(params?.row?.Emp_Name);
								setAssignDate(params?.row?.shift_date);
							}}
						>
							<img src="/images/assign-1.png" style={{ height: '15px' }} />
							Assign to shift
						</ButtonTheme>
						{permission.includes('Emp_Auth') && (displayTab !== 'display_by_date') && (params?.row?.isFilledBySelf === true) && (v3Data?.V3_ALL_SIGN_UP_UNASSIGN) && (
							<img
								src="/images/revert.png"
								onClick={() => {
									unAssignPosition(params?.row)
								}}
								width={20}
								height={20}
								style={{ cursor: 'pointer', marginLeft: '10px' }}
							/>)}
							{(displayTab === 'display_by_date') && (params?.row?.shift_status !== 'open') && (v3Data?.V3_ALL_SIGN_UP_UNASSIGN) &&
							<img
                                src="/images/eye.svg"
                                onClick={() => {
									assigedEmpDropdown(params?.row?.shift_date, params?.row?.shift_code, params?.row?.shift_start_time, params?.row?.shift_end_time)
									setUnAssignData(params?.row)
									setUnAssignModal(true)
                                }}
                                width={20}
                                height={20}
                                style={{ cursor: 'pointer', marginLeft: '10px' }}
								/>}
					</>
				),
		};

		if (tab === 'display_by_emp') {
			return [
				groupColumn,
				{
					field: 'date_1', headerName: 'Date', minWidth: 160,
					renderCell: (params) => moment(params.row.shift_date).format("MM/DD/YYYY")
				},
				{
					field: 'time', headerName: 'Time', flex: 1, minWidth: 600,
					renderCell: (params) => {
						const custom = params.row.is_custom === true;
						return (
							<>
								{params.row.start_time} - {params.row.end_time}
								{custom && (
									<div style={{
										color: "#000000",
										fontSize: "14px",
										fontWeight: "400",
										backgroundColor: "#E1EDE8",
										borderRadius: 50,
										padding: '10px 58px',
										width: "95px",
										height: "35px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										marginLeft: "10px"
									}}>
										Custom Time
									</div>
								)}
							</>
						)
					}
				},
				shiftStatusColumn,
				actionColumn
			];
		}

		if (tab === 'display_by_date') {
			return [
				groupColumn,
				{
					field: 'shift',
					headerName: 'Shift',
					flex: 1,
					minWidth: 160,
					maxWidth: 160,
					renderCell: (params) => {
						return (
							params.row.is_custom == true ?
								<div style={{
									color: "#000000",
									fontSize: "14px",
									fontWeight: "400",
									backgroundColor: "#E1EDE8",
									borderRadius: 50,
									padding: '10px 58px',
									width: "95px",
									height: "35px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}>
									Custom Time
								</div> :
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									{params.row.shift_start_time} - {params.row.shift_end_time}
								</div>
						);
					}
				},
				{
					field: 'volunteer',
					headerName: 'Volunteer',
					flex: 1,
					minWidth: 200,
					renderCell: (params) => {
						const employees = params.row.employees || [];

						return (
							<div style={{
								display: "flex",
								gap: "5px",
								alignItems: "center",
								overflow: "scroll",
								scrollbarWidth: "none"
							}}>
								{employees.map((e) => (
									<div key={e.Emp_Code} style={{
										color: "#fff",
										fontSize: "14px",
										fontWeight: "400",
										backgroundColor: "#7B7979",
										borderRadius: 50,
										padding: '2px 10px',
										minHeight: "35px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										whiteSpace: "nowrap"
									}}>
										{e.employee_name}
									</div>
								))}
							</div>
						);
					}
				},
				shiftStatusColumn,
				actionColumn
			];
		}

		return [groupColumn, shiftStatusColumn, actionColumn];
	};

	const loadEmployees = () => {
		ApiService.get('/employees-list?search=')
			.then(({ data }) => {
				var tempArr = []
				data.data.map((emp) => {
					var obj = emp
					obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName}`
					tempArr.push(obj)
				})
				setEmployees(tempArr)
			})
			.catch((e) => {
				console.error(e?.error)
			})
	}

	const getSignupList = () => {
		const body = {
			all_signup_type: displayTab,
			emp_codes: employeeName && employeeName.map(emp => emp.Emp_Code),
			start_date: moment(fromDate).format('YYYY-MM-DD'),
			end_date: moment(endDate).format('YYYY-MM-DD')
		};

		ApiService.post('/allSignups', body)
			.then((response) => {
				let temp = [];
				if (displayTab === 'display_by_emp') {
					response?.signups?.forEach(emp => {
						var newArr = [];
						emp.shifts.forEach(shift => {
							const newShift = { ...shift, Emp_Code: emp.Emp_Code, Emp_Name: emp.employee_name };
							newArr.push(newShift);
						});
						temp.push({
							data: newArr,
							name: emp.employee_name,
							shiftCount: emp.shifts.length
						});
					});
				} else if (displayTab === 'display_by_date') {
					response?.data?.forEach(dateGroup => {
						var newArr1 = [];
						dateGroup.shifts.forEach(shift => {
							const newShift = { ...shift, shift_date: dateGroup.shift_date };
							newArr1.push(newShift);
						});
						temp.push({
							data: newArr1,
							shift_date: dateGroup.shift_date,
							shiftCount: dateGroup.shifts.length
						});
					});
				}
				setEmpName(temp);
				setLoading(false);
			})
			.catch((err) => {
				console.error(err);
				toast.error(err?.message || "Failed to fetch signups");
				setLoading(false);
			});
	};

	const shiftDropdown = (date, code) => {
		const body = {
			Shift_Date: date,
			Shift_Code: code,
		};
		ApiService.post('/dropdown/assignments-with-positions', body)
			.then((res) => {
				const apiData = res.Assignments;
				const transformedOptions = [];
				apiData.forEach((assignment) => {
					const assignmentName = assignment.Assignment_Name;
					Object.entries(assignment.Positions).forEach(([shiftCode, positions]) => {
						positions.forEach((pos) => {
							transformedOptions.push({
								label: `${assignmentName} - ${shiftCode} - ${pos.Position_Name}`,
								value: pos.Position_Assignment_Id,
							});
						});
					});
				});
				setShiftOptions(transformedOptions);
			})
			.catch((e) => console.error(e?.error));
	};

	const assignPosition = () => {
		const body = {
			Shift_Date: assignShiftDate,
			Shift_Code: assignShiftCode,
			Start_Time: assignStartTimeCustom ? moment(assignStartTimeCustom).format('HH:mm:ss') : assignStartTime,
			End_Time: assignEndTimeCustom ? moment(assignEndTimeCustom).format('HH:mm:ss') : assignEndTime,
			Emp_Code: employeeAssignName ? employeeAssignName?.Emp_Code : assignEmpCode,
			Position_Assignment_Id: assignedTo?.value,
			isFullTime: isFultime,
			Force_Assign: ''
		}
		ApiService.post('/volunteer-assign-position', body)
			.then((data) => {
				toast.success(data?.message)
				setAssignModalOne(false)
				setAssignModalMultiple(false)
				setAssignShiftDate('')
				setAssignShiftCode('')
				setAssignStartTime('')
				setAssignEndTime('')
				setAssignedTo('')
				setEmployeeAssignName('')
				setIsCustom(false)
				getSignupList()
			})
			.catch((err) => {
				toast.error(err?.data?.message)
			})
	}

    const unAssignPosition = (data) => {
        const body = {
            "Shift_Date": unAssignData ? unAssignData.shift_date : data?.shift_date,
            "Shift_Code": unAssignData ? unAssignData.shift_code : data?.shift_code,
            "Start_Time": unAssignData ? unAssignData.shift_start_time : data?.start_time,
            "End_Time": unAssignData ? unAssignData.shift_end_time : data?.end_time,
            "Emp_Code": data?.Emp_Code,
            "Position_Assignment_Id": data?.Position_Assignment_Id
        }
        ApiService.post('/volunteer-unassign-position', body)
            .then((data) => {
                getSignupList()
                toast.success(data?.message)
                setUnAssignData('')
				setUnAssignModal(false)
            })
            .catch((err) => {
                toast.error('Error')
            })
    }

	const loadDropEmployees = (date, shift) => {
		const body = {
			Shift_Date: date,
			Shift_Code: shift
		};
		ApiService.post('/dropdown/employee-by-signup', body)
			.then((response) => {
				let tempArr = [];
				response.data.map((emp) => {
					let obj = emp
					obj.label = `${emp.employee.employee_assignment.EA_Rank ? emp.employee.employee_assignment.EA_Rank : ''} ${emp.employee.fullName}`;
					tempArr.push(obj);
				});
				setEmployeesAssign(tempArr);
			})
			.catch((e) => {
				console.error(e?.error);
			});
	};

	useEffect(() => {
		loadEmployees()
	}, [])

	useEffect(() => {
		getSignupList()
	}, [displayTab, employeeName, fromDate, endDate])
	
	const assigedEmpDropdown = (date, code, startTime, endTime) => {
        const body = {
            Shift_Date: date,
            Shift_Code: code,
            Start_Time: startTime,
            End_Time: endTime
        };
        ApiService.post('/dropdown/assigned-volunteers', body)
            .then((res) => {
				setEmployeesUnAssign(res?.employees)
            })
            .catch((e) => console.error(e?.error));
    };

	return (
		<>
			<Paper className="p-4" style={{ marginTop: "1rem" }}>
				<div className='mb-4'>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6} md={10}>
							<Typography variant="h5">Volunteer Signup</Typography>
						</Grid>

						{/* <Grid item xs={12} sm={6} md={2} sx={{ display: 'flex', justifyContent: 'end' }}>
                            <ButtonTheme type='submit' variant="filled" color='primary'
                                className='px-5' >
                                Save
                            </ButtonTheme>
                        </Grid> */}
					</Grid>
				</div>

				<div style={{ marginTop: '25px', display: 'flex', gap: '10px' }}>
					<Row>
						<Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
							<div style={{ width: '170px' }} className={activeTab == 'my-signups' ? 'tab-active mx-1' : 'tab-white mx-1'}
								onClick={() => {
									setActiveTab('my-signups')
									navigate('/firehouse/volunteer-signup-new')
								}}>
								My Signups
							</div>
						</Col>

						<Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
							<div style={{ width: '170px' }} className={activeTab == 'all-signups' ? 'tab-active mx-1' : 'tab-white mx-1'}
								onClick={() => setActiveTab('all-signups')}>
								All Signups
							</div>
						</Col>
					</Row>
				</div>
			</Paper >

			{loading ? (
				<Paper className="p-4" style={{ marginTop: "1rem" }}>
					<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '480px' }}>
						<CircularProgress />
					</Box>
				</Paper>
			) : (
				<Paper className="p-4" style={{ marginTop: "1rem" }}>
					<div className='mb-4'>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={6} md={6}>
								<ButtonTheme className='px-2 mt-1' style={{ backgroundColor: displayTab == 'display_by_emp' ? '#BF1D2D' : '#f3f3f3', color: displayTab == 'display_by_date' && '#333333', borderRadius: '5px', padding: '10px', width: '100%' }}
									onClick={() => {
										setDisplayTab('display_by_emp')
									}}>
									Display by Employee
								</ButtonTheme>
							</Grid>

							<Grid item xs={12} sm={6} md={6}>
								<ButtonTheme className='px-2 mt-1' style={{ backgroundColor: displayTab == 'display_by_date' ? '#BF1D2D' : '#f3f3f3', color: displayTab == 'display_by_emp' && '#333333', borderRadius: '5px', padding: '10px', width: '100%' }}
									onClick={() => {
										setDisplayTab('display_by_date')
									}}>
									Display by Date
								</ButtonTheme>
							</Grid>

                            <Grid item xs={12} sm={6} md={6}>
                                <p className="my-2">
                                    <span style={{ whiteSpace: 'nowrap' }}>
                                        Employee<span style={{ color: 'rgb(191, 29, 45)' }}>*</span>
                                    </span>
                                </p>
                                <Autocomplete
                                    multiple
                                    options={employees}
                                    value={employeeName}
                                    onChange={(event, newValue) => {
                                        setEmployeeName(newValue);
                                    }}
                                    sx={{
                                        "& .MuiInputBase-root": {
                                        minHeight: "50px",
                                        fontSize: "14px",
                                        display: "flex",
                                        alignItems: "center"
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        placeholder="Select Employee"
                                        />
                                    )}
                                />
                            </Grid>

							<Grid item xs={12} sm={6} md={3} className='d-grid'>
								<p className="my-2">
									<span style={{ whiteSpace: 'nowrap' }}>
										From<span style={{ color: 'rgb(191, 29, 45)' }}>*</span>
									</span>
								</p>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<ButtonDatePicker
										className='w-100'
										label={moment(fromDate).format('MM/DD/YYYY')}
										value={fromDate}
										onChange={(e) => setFromDate(e)}
									/>
								</LocalizationProvider>
							</Grid>

							<Grid item xs={12} sm={6} md={3} className='d-grid'>
								<p className="my-2">
									<span style={{ whiteSpace: 'nowrap' }}>
										To<span style={{ color: 'rgb(191, 29, 45)' }}>*</span>
									</span>
								</p>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<ButtonDatePicker
										className='w-100'
										label={moment(endDate).format('MM/DD/YYYY')}
										value={endDate}
										onChange={(e) => setEndDate(e)}
									/>
								</LocalizationProvider>
							</Grid>
						</Grid>
					</div>

                    {empName.map((item, idx) => (
                        <Col md={12} key={idx}>
                            <CollapseComponent
                                rows={item.data}
                                name={displayTab === 'display_by_emp'
                                    ? item.name ? `${item.name} (Available for ${item.shiftCount} shifts)` : ''
                                    : `${moment(item.shift_date).format("dddd, MMMM Do")}`}
                                columns={getColumns(displayTab)}
                                checkboxSelection={false}
                                open={true}
                            />
                        </Col>
                    ))}
                </Paper>
            )}
            {empName && !loading && empName.length === 0 &&
                <Paper className="p-4" style={{ marginTop: "1rem" }}>
                    <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 295 }}>
                        <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                        <span className='mt-4' style={{ color: '#555555' }}>
                            No Signups Found
                        </span>
                    </div>
                </Paper>}

			<Modal show={assignModalOne} onHide={() => setAssignModalOne(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Assign to Open Shift</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div style={{ color: '#555555' }}>
						You can schedule {assignEmpName} for the available shifts on {moment(assignDate).format("dddd, MMMM Do")}.
					</div>
					<div style={{ marginTop: '10px' }}>
						<div>
							<Grid item md={12} sm={12} lg={12} style={{ marginTop: '10px' }}>
								<p style={{ marginBottom: '4px' }}>Volunteer</p>
								<div style={{ border: '1px solid rgba(224, 224, 224, 1)', background: '#F9FAFB', borderRadius: '4px', height: '49px', padding: '10px' }}>
									{assignEmpName}
								</div>
							</Grid>
						</div>

						<div>
							<Grid item md={12} sm={12} lg={12} style={{ marginTop: '10px' }}>
								<p style={{ marginBottom: '4px' }}>Select Shift*</p>
								<Autocomplete
									options={shiftOptions}
									getOptionLabel={(option) => option.label}
									onChange={(event, newValue) => setAssignedTo(newValue)}
									sx={{
										"& .MuiInputBase-root": {
											height: "48px",
											fontSize: "14px",
											display: "flex",
											alignItems: "center"
										}
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											placeholder="Select Shift"
										/>
									)}
								/>
							</Grid>
						</div>
					</div>
					{isCustom == true &&
						<div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
							{/* Start Time Field */}
							<Col md={6}>
								<p style={{ marginBottom: '4px' }}>Start Time*</p>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<TimePicker
										className="m-0"
										value={assignStartTime}
										onChange={(newValue) => setAssignStartTimeCustom(newValue)}
										sx={{
											"& .MuiOutlinedInput-input": { color: 'black' },
											width: "100%",
											"& .MuiInputBase-root": {
												height: '48px',
												fontSize: '14px'
											},
										}}
									/>
								</LocalizationProvider>
							</Col>

							{/* End Time Field */}
							<Col md={6}>
								<p style={{ marginBottom: '4px' }}>End Time*</p>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<TimePicker
										className="m-0"
										value={assignEndTime}
										onChange={(newValue) => setAssignEndTimeCustom(newValue)}
										sx={{
											"& .MuiOutlinedInput-input": { color: 'black' },
											width: "100%",
											"& .MuiInputBase-root": {
												height: '48px',
												fontSize: '14px'
											},
										}}
									/>
								</LocalizationProvider>
							</Col>
						</div>
					}
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
								setAssignModalOne(false)
							}}>
								Cancel
							</ButtonTheme>
						</Col>

						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
								onClick={() => { assignPosition() }}
							>
								Save
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			<Modal show={assignModalMultiple} onHide={() => {
				setAssignModalMultiple(false)
				setEmployeeAssignName('')
			}}>
				<Modal.Header closeButton>
					<Modal.Title>Assign to Open Shift</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div style={{ color: '#555555' }}>
						You can schedule employees to shifts on {moment(assignDate).format("dddd, MMMM Do")}.
					</div>
					<div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
						<div>
							{/* Employee Field */}
							<div>
								<Grid item md={12} style={{ marginTop: '10px' }}>
									<p className='my-2'>Employee*</p>
									<Autocomplete
										options={employeesAssign}
										getOptionLabel={(option) => option.label || ''}
										value={employeeAssignName}
										onChange={(event, newValue) => { setEmployeeAssignName(newValue); }}
										sx={{
											"& .MuiInputBase-root": {
												height: "48px",
												fontSize: "14px",
												display: "flex",
												alignItems: "center"
											}
										}}
										renderInput={(params) => (
											<TextField
												{...params}
												placeholder="Select Employee"
											/>
										)}
									/>
								</Grid>
							</div>

							{/* Select Shift Field */}
							<div>
								<Grid item md={12} style={{ marginTop: '10px' }}>
									<p className='my-2'>Select Shift*</p>
									<Autocomplete
										options={shiftOptions}
										getOptionLabel={(option) => option.label}
										onChange={(event, newValue) => setAssignedTo(newValue)}
										sx={{
											"& .MuiInputBase-root": {
												height: "48px",
												fontSize: "14px",
												display: "flex",
												alignItems: "center"
											}
										}}
										renderInput={(params) => (
											<TextField
												{...params}
												placeholder="Select Shift"
											/>
										)}
									/>
								</Grid>
							</div>
						</div>
						{isCustom == true &&
							<div style={{ display: 'flex', gap: '10px' }}>
								{/* Start Time Field */}
								<Col md={6}>
									<p style={{ marginBottom: '4px' }}>Start Time*</p>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
										<TimePicker
											className="m-0"
											value={assignStartTime}
											onChange={(newValue) => setAssignStartTimeCustom(newValue)}
											sx={{
												"& .MuiOutlinedInput-input": { color: 'black' },
												width: "100%",
												"& .MuiInputBase-root": {
													height: '48px',
													fontSize: '14px'
												},
											}}
										/>
									</LocalizationProvider>
								</Col>

								{/* End Time Field */}
								<Col md={6}>
									<p style={{ marginBottom: '4px' }}>End Time*</p>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
										<TimePicker
											className="m-0"
											value={assignEndTime}
											onChange={(newValue) => setAssignEndTimeCustom(newValue)}
											sx={{
												"& .MuiOutlinedInput-input": { color: 'black' },
												width: "100%",
												"& .MuiInputBase-root": {
													height: '48px',
													fontSize: '14px'
												},
											}}
										/>
									</LocalizationProvider>
								</Col>
							</div>
						}
					</div>

					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
								setAssignModalOne(false)
								setEmployeeAssignName('')
							}}>
								Cancel
							</ButtonTheme>
						</Col>

                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
                                onClick={() => { assignPosition() }}
                            >
                                Save
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

			<Modal size="lg" show={unAssignModal} 
                onHide={() => {
                    setUnAssignModal(false) 
                    setEmployeesUnAssign([])
                    }}>
				<Modal.Body className='p-4'>
					<Modal.Header closeButton>
                    <Modal.Title>Unassign Shifts</Modal.Title>
                </Modal.Header>
					{/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Typography id="modal-modal-title" sx={{ fontSize: '21px', fontWeight: '700' }}>
							Un Assign
						</Typography>
						<img src="/images/close-icon.svg" style={{ cursor: 'pointer' }} onClick={() => setUnAssignModal(false)} />
					</div> */}

					<Box id="modal-modal-description">
						{loading &&
							<div className='my-5' style={{ display: 'flex', justifyContent: 'center' }}>
								<CircularProgress />
							</div>
						}

						{<>
							{!loading &&
								<div style={{ maxHeight: '60vh', overflowX: 'auto', scrollbarWidth: 'none' }}>
									<TableContainer component={Paper} sx={{
										boxShadow: 'none !important',
										border: '1px solid #EAECF0',
										mt: 2,
									}}>

										<Table aria-label="customized table">
											<TableHead sx={{ backgroundColor: "#E5E9EB" }} >
												<TableRow>
													<TableCell sx={{ minWidth: 130 }}>Name</TableCell>
													<TableCell sx={{ minWidth: 170 }}>Shift</TableCell>
													<TableCell sx={{ minWidth: 150 }} >Position Assignment</TableCell>
													<TableCell sx={{ minWidth: 200 }}>Action</TableCell>
												</TableRow>
											</TableHead>

											<TableBody>
												{employeesUnAssign?.length > 0 ? employeesUnAssign.map((row) => (
													<TableRow key={row?.Emp_Code} sx={{
														height: '22px',
														'& .MuiTableCell-root': {
															border: 'none',
															color: row?.Has_Volunteer_Signup === false ? 'red !important' : 'inherit'
														},
														'&:nth-of-type(even)': {
															backgroundColor: 'rgba(204, 204, 204, 0.2)',
														},
													}}>

														<TableCell component="th" scope="row">
															{row?.employee_name}
														</TableCell>

                                                        <TableCell component="th" scope="row">
															{row?.Start_Time} - {row?.End_Time}
														</TableCell>

														<TableCell component="th" scope="row">
															{row?.Position_Assignment_Name}
														</TableCell>

														<TableCell component="th" scope="row">
															<ButtonTheme
																className='px-2 mt-1'
																style={{
																	backgroundColor: '#BF1D2D',
																	borderRadius: '10px',
																	gap: '3px',
																	padding: '4px',
																}}
																onClick={() => {
																	unAssignPosition(row)
                                                                    setEmployeesUnAssign([])
																}}
															>
																<img src="/images/assign-1.png" style={{ height: '15px' }} />
																Unassign
															</ButtonTheme>
														</TableCell>

													</TableRow>
												))
													:
													<TableRow>
														<TableCell colSpan={6} style={{ textAlign: 'center' }}>
															No results found
														</TableCell>
													</TableRow>
												}
											</TableBody>
										</Table>
									</TableContainer>
								</div>
							}
						</>}
					</Box>
				</Modal.Body>
			</Modal>
        </>
    )
}

export default AllSignups;